import { RequestDiagnostics } from '../requestDiagnostics';

export interface IQuery<TResult> {
    QueryType: string;

    //This is just for TypeScript compiler... no use of it other way.
    __typeCall: (queryResult: TResult) => TResult;
}

export class Query<TResult> implements IQuery<TResult> {
    public QueryType = '';

    public constructor(commandType: string) {
        this.QueryType = commandType;
    }

    //This is just for TypeScript compiler... no use of it other way.
    public __typeCall(commandResult: TResult): TResult {
        return commandResult;
    }
}

export interface IQueryExecutor {
    executeQuery<TQuery extends IQuery<TResult>, TResult>(query: TQuery, errorCallback?: (error: any) => { isHandled: boolean; result?: TResult }, diagnostics?: RequestDiagnostics): Promise<TResult>;
    abortAllRuningQuery(): void;
}
